import './login.scss';

import React from 'react';
import Authentication from '../../authentication';
import { Redirect } from 'react-router';

export default class extends React.Component {

  state = {
    username: '',
    password: '',
    error: '',
    loading: false,
    success: false
  };

  onInputEvent = ({ target }) => {
    const { name, value } = target;
    this.setState({
      [name]: value
    });
  };

  /**
   * @param {Event} event
   * @returns {Promise}
   */
  async onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const promise = await new Promise((resolve) => this.setState({
      loading: true,
      error: ''
    }, resolve));

    try {
      await Authentication.authenticate(
        this.state.username,
        this.state.password
      );
    } catch(e) {
      console.warn(e);
      await promise;
      return new Promise((resolve) => this.setState({
        password: '',
        error: 'The username or password provided is incorrect',
        loading: false
      }, resolve));
    }

    console.log("waiting promise");
    await promise;
    console.log("promise complete");

    return new Promise((resolve) => this.setState({
      password: '',
      success: true
    }, resolve));
  };

  render() {
    console.log((!this.loading && Authentication.isAuthenticated()) || this.state.success, this.state);
    if ((!this.loading && Authentication.isAuthenticated()) || this.state.success) {
      return <Redirect to="/feedback" />
    }

    return (
      <div className="login-container">
        <form className="login-form-container pure-form pure-form-stacked">
          <fieldset>
            <h3>Login</h3>
            {
              this.state.error ? (
                <p className="pure-form-message-inline error">{this.state.error}</p>
              ) : null
            }

            <div className="pure-control-group">
              <label htmlFor="username">Username</label>
              <input name="username" id="username" type="text" placeholder="Username" required onChange={this.onInputEvent} value={this.state.username} disabled={this.loading} />
            </div>

            <div className="pure-control-group">
              <label htmlFor="password">Password</label>
              <input name="password" id="password" type="password" placeholder="Password" required onChange={this.onInputEvent} value={this.state.password} disabled={this.loading} />
            </div>

            <div className="pure-controls">
              <button type="submit" onClick={this.onSubmit.bind(this)} disabled={!(this.state.username && this.state.password) || this.loading}>
                Log in
              </button>
            </div>
          </fieldset>

        </form>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/pages/login/index.js